// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import favoritesReducer from '../features/favorites/favoritesSlice';
// import other slices …

export const store = configureStore({
  reducer: {
    favorites: favoritesReducer,
    // …other slices…
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
